import React from 'external/react';
import PropTypes from 'external/prop-types';

import {
  Accordion as ReactAccessibleAccordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel, AccordionItemState,
} from 'react-accessible-accordion';

export function Item({ title, children, uuid }) {
  return (
    <AccordionItem uuid={uuid}>
      <AccordionItemHeading>
        <AccordionItemButton>
          {title}
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        {children}
      </AccordionItemPanel>
    </AccordionItem>
  );
}

Item.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  uuid: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
};

export function Accordion({
  allowMultipleExpanded = true,
  allowZeroExpanded = true,
  className = '',
  children,
  preExpanded
}) {
  return (
    <ReactAccessibleAccordion
      className={`fliwas-accordion ${className}`}
      allowMultipleExpanded={allowMultipleExpanded}
      allowZeroExpanded={allowZeroExpanded}
      preExpanded={preExpanded}
    >
      {children}
    </ReactAccessibleAccordion>
  );
}

Accordion.Item = Item;
Accordion.ItemState = AccordionItemState;

Accordion.propTypes = {
  allowMultipleExpanded: PropTypes.bool,
  allowZeroExpanded: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  preExpanded: PropTypes.arrayOf(PropTypes.string),
};



// WEBPACK FOOTER //
// ./js/components/Accordion.jsx